import React from 'react';
import ScrollMagie from '../../helpers/scrollmagie'

export default class detail extends React.Component {

    componentDidMount() {
        $("html, body").animate({scrollTop: 0}, 0);
        new ScrollMagie()
    }

    render() {
        return <section>
            <div className="fullscreen-image fixed"
                 style={{backgroundImage: "url(public/images/boldideas/cover.jpg)"}}>
                <div className="scroll-down-wrapper">
                    <div className="scroll-down">
                        <p>Scroll<br/>down</p>
                        <img src="public/images/scroll.svg" alt=""/>
                    </div>
                </div>
            </div>
            <div style={{paddingTop: "10vw", paddingBottom: "0vw"}}>
                <div className="container">
                    <div className="row">
                        <div className="gr-7 relative">
                            <div className="image" style={{position: "absolute", zIndex: 1}}>
                                <div className="animate" data-transform-y="10%" data-transform-duration="100%">
                                    <img src="public/images/20150612-JMK_1874-Bearbeitet-Bearbeitet.jpg" alt=""
                                         className="image-resp"/>
                                </div>
                            </div>
                        </div>
                        <div className="gr-5" style={{position: "relative", zIndex: 0}}>
                            <div className="padding-dynamic-left-3 padding-dynamic-bottom-3">
                                <div className="animate" data-transform-y="-10%" data-transform-duration="100%">
                                    <h1>BOLD<br/>IDEAS</h1>
                                    <div style={{width: "96%"}}>
                                        <p>
                                            Extravagante und außergewöhnliche Umsetzungen.<br/>
                                            Dabei geht es vielfach um das
                                            Einnehmen eines neuen Betrachtungswinkels abseits des Gewohnten um ein
                                            Produkt in einem ganz neuen Licht zeigen zu können.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="gr-12" style={{position: "relative", zIndex: 2}}>
                            <div className="row">
                                <div className="gr-5">
                                    &nbsp;
                                </div>
                                <div className="gr-7">
                                    <div className="image padding-dynamic-bottom-3">
                                        <div className="animate" data-transform-y="-10%" data-transform-duration="100%">
                                            <img src="public/images/20160723-JK2_1962-Bearbeitet.jpg" alt=""
                                                 className="image-resp transform-r-0"/>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{
                backgroundImage: "url(public/images/boldideas/full_1.jpg)",
                backgroundSize: "cover",
                paddingTop: "20vw",
                paddingBottom: "20vw",
                color: "white"
            }}>
                <div className="intro-wrapper">
                    <div className="row">
                        <div className="gr-4">
                            <div className="project">
                            <h1 style={{fontSize: "4.7vw"}}>TEUBL<br/>KALENDER<br/>BOX</h1>
                            <p>
                                Für den Baustoffhändler Teubl wurden im Rahmen des Kalenderboxshoot 2017, Baustoffe so
                                inszeniert, dass sie auf den ersten Blick als solche nicht erkennbar sind.
                                Bemerkenswerte Bilder für eine besondere Art von Kalender.
                            </p>
                            </div>
                        </div>
                        <div className="gr-8">&nbsp;</div>
                    </div>
                </div>
            </div>

            <div className="section-wrapper" style={{marginBottom: "0vw"}}>

                <div className="row">
                    <div className="gr-6"
                         style={{position: "relative", zIndex: 0, transform: "translate(0px, 15vw)"}}>
                        <div className="image transform-r-0">
                            <div className="animate" data-transform-y="-20%" data-transform-duration="200%">
                                <img src="public/images/boldideas/collage_2_2.jpg" alt="" className="image-resp"/>
                            </div>
                        </div>
                    </div>

                    <div className="gr-6">
                        <div className="image transform-l-0">
                            <div className="animate" data-transform-y="20%" data-transform-duration="200%">
                                <img src="public/images/boldideas/collage_2_1.jpg" alt=""
                                     style={{width: "92%", float: "right", transform: "translate(0px, -5vw)"}}/>
                                <div className="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="image text-center" style={{marginTop: "-10vw", position: "relative", zIndex: 2,}}>
                    <div className="animate" data-transform-y="-10%" data-transform-duration="150%">
                        <img src="public/images/boldideas/collage_2_3.jpg" alt="" className="image-resp"
                             style={{width: "70vw"}}/>
                    </div>
                </div>

            </div>


            <div className="fullscreen-image "
                 style={{backgroundImage: "url(public/images/boldideas/full_2.jpg)"}}></div>


            <div className="fullscreen-image "
                 style={{backgroundImage: "url(public/images/boldideas/full_3.jpg)"}}></div>

            <div style={{height: "200px"}}>&nbsp;</div>

            <div className="fullscreen-image "
                 style={{backgroundImage: "url(public/images/boldideas/full_4.jpg)"}}></div>

            <div className="padding-dynamic-4" style={{background: "black", color: "#888"}}>
                <div className="row row-align-middle">
                    <div className="gr-8">
                        <img src="public/images/boldideas/full_5.jpg" alt="" className="image-resp"/>
                    </div>
                    <div className="gr-4">
                        <div style={{paddingLeft: "40px", paddingTop: "0px"}}>
                            <h1 style={{marginTop: 0}}>BLACK<br/>EDITION</h1>
                            <div className="width-percent-70">
                                <p>
                                    Für die KTM Xbow Black Edition entstanden außergewöhnliche Bilder, die bei jedem
                                    Betrachter sofort eine Geschichte im Kopf auslösen. Zudem Preisgekrönte Bilder beim
                                    Green Panther Award 2016
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="fullscreen-image fixed"
                 style={{
                     backgroundImage: "url(public/images/20150612-JMK_1906-Bearbeitet-Bearbeitet.jpg)",
                     height: "65vw"
                 }}></div>

            <div className="next animate">
                <div className="row">
                    <div className="gr-12">
                        <a href="#/categories/visualbranding">
                            <h1>NEXT</h1>
                        </a>
                    </div>
                </div>
            </div>

        </section>
    }
}



// WEBPACK FOOTER //
// ./src/scripts/pages/categories/boldideas.jsx